<template>
  <div v-if="mode === 'last' || mode === 'create'" class="em-tip">
    <div class="em-tip-head">
      <span>{{ mode === "last" ? "Último diagnóstico" : "Crear Diagnóstico" }}</span>
      <span v-if="mod" class="em-tip-icon">
        <i class="material-icons">{{ mod.icon }}</i>
      </span>
    </div>
    <p v-if="mode === 'last'" class="em-tip-body">
      <strong>{{ lastName }}</strong> es el último diagnóstico creado<span
        v-if="lastDate"
      >
        el {{ lastDate }}</span
      >.
    </p>
    <p v-else class="em-tip-body">
      Actualmente esta empresa no tiene diagnóstico en
      {{ mod ? mod.label : params.colDef.headerName }}.
      <br />
      <strong>Clic en la celda para crear uno nuevo.</strong>
    </p>
  </div>
  <div v-else class="em-tip em-tip--plain">{{ params.value }}</div>
</template>

<script>
import { formatLongDate, getLastProcess, getModule } from "../helpers";

export default {
  name: "DiagnosisTooltip",
  computed: {
    mode() {
      const value = this.params.value;
      return value === "last" || value === "create" ? value : null;
    },
    mod() {
      return getModule(this.params.colDef && this.params.colDef.colId);
    },
    last() {
      return getLastProcess(this.params.data, this.params.colDef.colId);
    },
    lastName() {
      return this.last ? this.last.nombre || this.last.name : "";
    },
    lastDate() {
      return this.last
        ? formatLongDate(this.last.created || this.last.createdAt)
        : "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/empresas/components/DiagnosisTooltip.vue